import { authService, bdltService } from '../../services'
import router from '@/router/router'

var token = JSON.parse(localStorage.getItem('token'))
const initialState = token ? { status: { loggedIn: true, loading: false }, token, user: null, apiVersion: null } : { status: {}, token: null, user: null, apiVersion: null }

export const authentication = {
    namespaced: true,
    state: initialState,
    getters: {
        apiVersion: (state) => {
            if (state.apiVersion == null) {
                authService.getApiVersion().then(data => {
                    state.apiVersion = data
                })
            }
            return state.apiVersion
        },
        token: (state) => {
            return state.token
        },
        user: (state) => {
            return state.user || JSON.parse(localStorage.getItem('user'))
        },
        loggedIn: (state) => {
            return state.status && state.status.loggedIn
        },
        loading: (state) => {
            return state.status.loading
        }
    },
    actions: {

        async login({ dispatch, commit }, { username }) {
            commit('loginRequest');
            await localStorage.removeItem('user')
            try {
                const response = await authService.currentUser(username);
                const token = response.token || response.data?.token;
                await commit('loginSuccess', { token, user: response });

                await bdltService.login(); // si c'est synchrone, sinon await

            } catch (e) {
                commit('loginFailure', username);
                dispatch(
                    'alert/error',
                    {
                        statusCode: 403,
                        message: "Votre compte n'est pas autorisé à accéder à cette application"
                    },
                    { root: true }
                );
            }
        },

        refreshToken ({ dispatch, commit }) {

            bdltService.refreshToken()

            /*authService.currentUser(creds.unique_name).then(user => {
                commit('loginSuccess', { 'token': refreshedToken, user })
                let query = router.currentRoute.query
                let redirect = query ? query.redirect : null
                if (redirect) {
                    router.push(redirect)
                }
            })*/
        },

        async logout ({ commit }) {
            await authService.logout()
            window.location.reload()
        }
    },
    mutations: {
        loginRequest (state) {
            state.status = { loggedIn: false, loading: true }
        },
        loginSuccess (state, { token, user }) {
            state.status = { loggedIn: true, loading: false }
            state.user = user
            state.token = token

            localStorage.setItem('user', JSON.stringify(user))
        },
        loginFailure (state) {
            state.status = { loggedIn: false, loading: false }
            state.user = null
            localStorage.removeItem('user')
            localStorage.removeItem('token')
        },
        logout (state) {
            this.loginFailure(state)
        },
        updateApiVersion (state, version) {
            state.apiVersion = version
        }
    }
}
